<template>
	<div>
		<el-form ref="joinform" :model="form" label-width="80px" size="mini">
			<el-form-item label="序列号" class="item">
				<el-input v-model="form.number" readonly></el-input>
			</el-form-item>
			<el-form-item label="ERP单号" class="item">
				<el-input v-model="form.ordercode" readonly></el-input>
			</el-form-item>
			<el-form-item label="线上单号" class="item">
				<el-input v-model="form.tptid" readonly></el-input>
			</el-form-item>
			<el-form-item label="公司抬头" class="item">
				<el-input v-model="form.invoicetitle" readonly></el-input>
			</el-form-item>
			<el-form-item label="企业税号" class="item">
				<el-input v-model="form.invoicetaxid" readonly></el-input>
			</el-form-item>
		</el-form>
		<el-divider content-position="center">合并列表</el-divider>
		<vxe-table ref="joinorderTable" style="margin-top: 8px;" :data="data" size="mini" max-height="400px"
			:checkbox-config="{trigger: 'row'}" border @checkbox-change="checkboxChange" @checkbox-all="checkboxChange">
			<vxe-column type="checkbox" width="40"></vxe-column>
			<vxe-column field="number" title="序列号"></vxe-column>
			<vxe-column field="ordercode" title="ERP单号"></vxe-column>
			<vxe-column field="tptid" title="线上单号"></vxe-column>
			<vxe-column field="invoicetitle" title="发票抬头"></vxe-column>
			<vxe-column field="paymentamount" title="付款金额"></vxe-column>
		</vxe-table>


	</div>
</template>
<style>

</style>
<style scoped>
	.item {
		margin-bottom: 4px;
	}
</style>
<script>
	export default {
		name: 'invoiceoutputJoinIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				data: [],
				form: {
					id: 0,
					number: '',
					ordercode: '',
					tptid: '',
					invoicetitle: '',
					invoicetaxid: '',
					joinids:[]
				}
			}
		},
		watch: {

		},
		created() {

			this.$api.invoiceoutput.list({
				invoicetaxid: this.row.invoicetaxid,
				invoicestatus: 318,
				currentPage: -1
			}).then((res) => {

				res.list.forEach((item) => {
					// console.log(item.ordercode != this.row.ordercode)
					if (item.number != this.row.number) {
						this.data.push(item)
					}
				})
			})
		},
		mounted() {
			this.form.id = this.row.id
			this.form.number = this.row.number
			this.form.ordercode = this.row.ordercode
			this.form.tptid = this.row.tptid
			this.form.invoicetitle = this.row.invoicetitle
			this.form.invoicetaxid = this.row.invoicetaxid
		},
		computed: {

		},

		methods: {
			submit() {
				if(this.form.joinids.length!=0){
						return this.form
				}else{
					this.$message.error('请选择单号')
					return false
				}
				// if (this.form.amount == 0) {
				// 	this.$message.error('原金额不能为0')
				// 	return false
				// } else if (this.form.splitamount == 0) {
				// 	this.$message.error('拆分金额不能为0')
				// } else {
				// 	return this.form
				// }

			},
			checkboxChange() {
				this.form.joinids = []
				let data = this.$refs.joinorderTable.getTableData()
				data.fullData.forEach((item) => {
					if (this.$refs.joinorderTable.isCheckedByCheckboxRow(item)) {
						this.form.joinids.push(item.id)
					}		
				})
			}
		},
		components: {

		}
	}
</script>
